import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import RestaurantService from "../services/RestaurantService";

export const RestaurantContext = createContext("RestaurantContext");

const RestaurantContextProvider = ({children}) => {

    const [restaurantList, setRestaurantList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingRestaurantList, setLoadingRestaurantList] = useState(false);

    const [personalRestaurantList, setPersonalRestaurantList] = useState([]);
    const [personalRestaurantTotalElements, setPersonalRestaurantTotalElements] = useState(0);
    const [personalRestaurantLoading, setPersonalRestaurantLoading] = useState(false);

    const getRestaurantList = async params => {
        try {
            setLoadingRestaurantList(true);
            const response = await RestaurantService.getRestaurantList(params);
            setRestaurantList(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoadingRestaurantList(false);
        } catch (error) {
            setLoadingRestaurantList(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
        }

    }

    const getPersonalRestaurantList = async params => {
        try {
            setPersonalRestaurantLoading(true);
            const response = await RestaurantService.getPersonalRestaurantList(params);
            setPersonalRestaurantList(response.data.content);
            setPersonalRestaurantTotalElements(response.data.totalElements);
            setPersonalRestaurantLoading(false);
        } catch (error) {
            setPersonalRestaurantLoading(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
        }

    }

    return (
        <RestaurantContext.Provider
            value={{
                loadingRestaurantList,
                personalRestaurantLoading,
                totalElements,
                personalRestaurantTotalElements,
                restaurantList,
                personalRestaurantList,
                getRestaurantList,
                getPersonalRestaurantList,
            }}
        >
            {children}
        </RestaurantContext.Provider>
    );
}

export default RestaurantContextProvider;
